import { createStore } from '..'
import { ExchangeActivity } from '../../interfaces/transactionActivity'
import { StateStorage } from 'zustand/middleware'

interface UserConvertsStore {
  savedConverts: { [key: string]: ExchangeActivity[] }
  addConvert: (walletId: string, convert: ExchangeActivity) => void
}

export const createUserConvertStore = (storage: StateStorage) =>
  createStore<UserConvertsStore>(
    storage,
    (set, get) => ({
      savedConverts: {},
      addConvert(walletId, convert) {
        const { savedConverts } = get()

        const existingsConverts = savedConverts[walletId] || []

        set({
          savedConverts: {
            ...savedConverts,
            [walletId]: [...existingsConverts, convert],
          },
        })
      },
    }),
    {
      persist: {
        name: 'userConverts',
        version: 0,
      },
    }
  )
